import { MarketingNav } from './MarketingNav';
import { MarketingHero } from './MarketingHero';
import { MarketingPlatforms } from './MarketingPlatforms';
import { MarketingFeatures } from './MarketingFeatures';
import { MarketingPricing } from './MarketingPricing';
import { MarketingFAQ } from './MarketingFAQ';
import { ROICalculator } from '../ROICalculator';
import { MarketingFooter } from './MarketingFooter';

export function MarketingHomepage() {
  return (
    <div className="min-h-screen bg-white text-slate-900 antialiased">
      <MarketingNav />
      <main>
        <MarketingHero />
        <MarketingPlatforms />
        <MarketingFeatures />
        <MarketingPricing />
        {/* PathKit's return for a prospective firm (ledger: the marketing site's ROI calculator, step 5) */}
        <section id="roi" className="py-16 sm:py-24 bg-slate-50">
          <div className="mx-auto max-w-5xl px-6">
            <ROICalculator />
          </div>
        </section>
        <MarketingFAQ />
      </main>
      <MarketingFooter />
    </div>
  );
}
